export default __webpack_public_path__ + "static/media/Logo-St-mini.0175a305.svg";